import { DEFAULT_SCHEDULING_ALERT_NOTE } from '@clinic/shared';
import type { Patient, PatientSchedulingAlertMode } from './types';

export function patientSchedulingAlertMode(patient: Patient): PatientSchedulingAlertMode {
  return (
    patient.schedulingAlertMode ??
    (patient.requiresAdvancePayment ? 'dashboard_and_scheduling' : 'discarded')
  );
}

export function patientSchedulingAlertNote(patient: Patient): string {
  return patient.schedulingAlertNote?.trim() || DEFAULT_SCHEDULING_ALERT_NOTE;
}

export function hasPatientSchedulingAlert(patient: Patient): boolean {
  return patientSchedulingAlertMode(patient) !== 'discarded';
}
